import { type Customer } from "@repo/api";
import { useEffect, useMemo, useRef } from "react";

import { useCustomer } from "../hooks/useCustomer";
import { CustomerCard } from "./CustomerCard";

interface CustomerCardProps {
  editable?: boolean;
  projectId?: number;
  orderId?: string;
  isAppointmentOrder?: boolean;
  setCustomer?: (customer: Customer) => void;
}

export const CustomerCardWrapper = ({
  editable = true,
  projectId,
  orderId,
  isAppointmentOrder,
  setCustomer,
}: CustomerCardProps) => {
  const { customer, customerSource, isValidating } = useCustomer(
    projectId,
    orderId,
    isAppointmentOrder
  );

  // Memoize customer to avoid triggering effect unnecessarily
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedCustomer = useMemo(() => customer, [customer?.partyId]);

  // Track previous customer to avoid infinite loops
  const prevCustomerRef = useRef<Customer | null>(null);

  useEffect(() => {
    if (
      setCustomer &&
      memoizedCustomer &&
      memoizedCustomer !== prevCustomerRef.current
    ) {
      setCustomer(memoizedCustomer);
      prevCustomerRef.current = memoizedCustomer;
    }
  }, [memoizedCustomer, setCustomer]);

  return (
    <CustomerCard
      customer={customer}
      editable={editable}
      isValidating={isValidating}
      customerSource={customerSource}
    />
  );
};
